import React from "react";


export default function LinkComponent(props) {

    const { text , ...properties } = props;

    return <a  href="#"  {...properties} > {text}</a>;
}